import "./CasinoPaymentType.scss";
import { CASINO_URL_MENTIONS_LEGALES } from "app/constants";
import EcheancierCasinoContainer from "app/pages/Booking/Payment/Casino/EcheancierCasinoContainer";
import { FormattedMessage } from "react-intl";
import CasinoCustomerFieldset from "app/pages/Booking/Payment/Casino/CasinoCustomerFieldset";
import PropTypes from "prop-types";
import CreditCardPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/creditCard/CreditCardPaymentType";
import { paymentTypesValues } from "app/utils/propTypes";

const CasinoPaymentType = ({
	payNowAmount,
	onCreditCardInputsBlur,
	showMaidenName,
	selectedPaymentType,
}) => {
	return (
		<div className="casino-payment-type">
			<div className="casino-payment-type__echeancier">
				<EcheancierCasinoContainer />
			</div>

			<CasinoCustomerFieldset
				showMaidenName={showMaidenName}
				selectedPaymentType={selectedPaymentType}
			/>

			<CreditCardPaymentType
				payNowAmount={payNowAmount}
				onCreditCardInputsBlur={onCreditCardInputsBlur}
			/>

			<div className="casino-payment-type__casino-more-info">
				<FormattedMessage
					id="payment.method.casino.data.protection.info.1"
					tagName="span"
				/>
				<FormattedMessage
					id="payment.method.casino.data.protection.info.2"
					tagName="span"
					values={{
						casinoURL: (
							<a
								rel="noopener noreferrer"
								target="_blank"
								href={CASINO_URL_MENTIONS_LEGALES}
							>
								<FormattedMessage id="payment.method.casino.data.protection.url.label" />
							</a>
						),
					}}
				/>
			</div>
		</div>
	);
};

CasinoPaymentType.propTypes = {
	payNowAmount: PropTypes.number,
	showMaidenName: PropTypes.bool,
	onCreditCardInputsBlur: PropTypes.func,
	selectedPaymentType: paymentTypesValues,
};

export default CasinoPaymentType;
